export default {
  create_qrph: 'Crear QR Stand',
  qr_stand_type: 'Tipo de QR Stand',
  qr_stand_name: 'Nombre del QR Stand',
  new_link: 'Nuevo enlace',
  edit_link: 'Editar enlace',
  single_payment_link: 'Enlaces de pago único',
  batch_payment_link: 'Enlaces de pago por lotes',
  batch_link_details: 'Detalles del enlace por lotes',
  cancel_upload: 'Cancelar subida',
  proceed_upload: 'Continuar con la subida',
  duplicate_upload_detected: 'Se detectó una carga duplicada',
  tip_1: 'Seleccione el método de pago y el canal, luego complete los detalles del enlace de pago',
  tip_2: 'Descargue y rellene la plantilla para crear enlaces por lotes',
  tip_3: 'Suba el archivo Excel rellenada utilizando la última plantilla para enviar enlaces por lotes',
  tip_4: 'Cree enlaces de pago por lotes cargando un archivo Excel para recibir pagos a través de múltiples cuentas bancarias o billeteras electrónicas.',
  tip_5: 'Cree un enlace de pago para recibir pagos únicamente en una cuenta bancaria o billetera electrónica específica.',
  tip_6: 'Está intentando subir un archivo que ya existe. Verifique el archivo que está cargando y asegúrese de que desea continuar con esta operación.',
  active_status: 'Estado de vigencia',
  active: 'Activo',
  inactive: 'Inactivo',
  payment_status: 'Estado del pago',
  paid: 'Pagado',
  unpaid: 'No pagado',
  link_id: 'ID del enlace',
  link_no: 'Número de enlace',
  title: 'Título',
  amount: 'Monto',
  type: 'Tipo',
  create_time: 'Fecha y hora de creación',
  complete_time: 'Fecha y hora de finalización',
  remark: 'Notas',
  copy_link: 'Copiar enlace',
  link_qr: 'Enlace',
  show_qr_code: 'Mostrar código QR',
  link_info: 'Información del enlace',
  link_title: 'Título del enlace',
  order_mode: 'Modo de la orden',
  fixed_amount: 'Monto fijo',
  based_on_product: 'Basado en el producto',
  customer_to_enter: 'Monto ingresado por el cliente',
  product: 'Producto',
  add_another_product: 'Agregar otro producto',
  add_new_product: 'Agregar nuevo producto',
  edit_product: 'Editar producto',
  product_info: 'Información del producto',
  product_name: 'Nombre del producto',
  price: 'Precio',
  quantity: 'Cantidad',
  allow_adjust: 'El usuario puede modificar la cantidad.',
  image: 'Imagen',
  payment_description: 'Descripción del pago',
  customer_info: 'Información del cliente',
  collect_customer_info: 'Recopilar información del cliente',
  customer_name: 'Nombre del cliente',
  customer_email: 'Correo del cliente',
  customer_mobile: 'Teléfono celular del cliente',
  other_info: 'Otra información',
  add_customer_field: 'Agregar información personalizada',
  text: 'Texto',
  number_only: 'Solo números',
  marked_as_required: 'Obligatorio',
  mark_as_optional: 'Opcional',
  add_another_field: 'Agregar otro campo',
  link_configuration: 'Configuración del enlace',
  link_type: 'Tipo de enlace',
  one_time: 'De un solo uso',
  reusable: 'Reutilizable',
  max_of_payments_accepted: 'Límite de transacciones exitosas',
  expiry_time: 'Fecha de expiración',
  edit_payment_link: 'Editar enlace de pago',
  create_payment_link: 'Crear enlace de pago',
  payment_link_details: 'Detalles del enlace de pago',
  download_qr_code: 'Descargar código QR',
  checkout_order_id: 'ID de orden de checkout',
  transaction_id: 'ID de transacción',
  payment_channel: 'Canal de pago',
  link_details: 'Detalles del enlace',
  transactions: 'Transacciones',
  other: 'Otros',
  custome_field: 'Información personalizado',
  time_zone_tips: 'La zona horaria actual es',
  merchant_order_id: 'ID de orden del comercio',
  link_expired_tips: 'El enlace ha expirado',
  reach_payment_limit_tips: 'Se ha alcanzado el límite de pagos',
  both_tips: 'El enlace ha expirado y se ha alcanzado el límite de pagos',
  overview: 'Resumen',
  checkout_details: 'Detalles del checkout',
  transaction_details: 'Detalles de la transacción',
  time_line: 'Línea de tiempo',
  payment_breakdown: 'Detalles del pago',
  order_amount: 'Monto de la orden',
  transaction_fee: 'Comisión por transacción',
  payment_amount: 'Monto de pago',
  customer_payin_journey: "Historial de transacciones",
  delete_product_tips: 'Este producto se eliminará del catálogo, por favor confirme.',
  add_product_or_search_on_list: 'Añadir o buscar producto en la lista',
  no_more_data: 'No hay más datos disponibles',
  unlimited: 'Ilimitado',
  transaction_fee_charge_mode: 'Modo de asignación de comisión',
  transaction_fee_charge_mode1: 'Asumido por el comercio',
  transaction_fee_charge_mode2: 'Asumido por el usuario',
  link_icon: 'Ícono del enlace de pago',
  upload_photo: 'Subir imagen',
  available_edits_left: 'Número de ediciones restantes',
  create_successful_tips: '¡Enlace de pago creado correctamente! Compártalo con su cliente.',
  update_successful_tips: '¡Su enlace de pago se ha editado correctamente!',
  field_empty_tips: 'Ingrese el nombre de la información personalizada en la sección "Otra información".',
  duplicate_label_name: 'El nombre del campo ya existe.',
  label_name: 'Nombre del campo',
  only_successful_transactions: 'Solo incluir transacciones exitosas',
  branch_code: 'Código de sucursal',
  branch_name: 'Nombre de la sucursal',
  payment_success_page: 'Página de pago exitoso',
  custom_message: 'Mensaje personalizado',
  max_file_tips: 'El tamaño de la imagen no debe exceder los 2 MB, por favor vuelva a intentarlo',
  min_img_resolution: ''
}
